import React, { useState } from "react";
import { FaCopy, FaTrash } from "react-icons/fa";
import JSONPretty from "react-json-pretty";
import { toast, ToastContainer } from "react-toastify";

const VideoSchemaForm = () => {
  const [formData, setFormData] = useState({
    name: "",
    description: "",
    uploadDate: "",
    durationMinutes: "",
    durationSeconds: "",
    thumbnailUrl: "",
    contentUrl: "",
    embedUrl: "",
    seekToAction: "",
  });

  const [generatedSchema, setGeneratedSchema] = useState({
    "@context": "https://schema.org",
    "@type": "VideoObject",
    "name": "demo",
    "description": "demo",
    "uploadDate": "2025-01-09",
    "thumbnailUrl": "https://example.com/",
    "contentUrl": "https://example.com/",
    "embedUrl": "https://example.com/",
    "duration": "PT10M600S",
    "potentialAction": {
      "@type": "SeekToAction",
      "target": "https://example.com/"
    }
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const generateSchema = () => {
    const duration =
      formData.durationMinutes || formData.durationSeconds
        ? `PT${formData.durationMinutes || 0}M${formData.durationSeconds || 0}S`
        : undefined;

    const schema = {
      "@context": "https://schema.org",
      "@type": "VideoObject",
      "name": formData.name,
      "description": formData.description,
      "uploadDate": formData.uploadDate,
      "thumbnailUrl": formData.thumbnailUrl,
      "contentUrl": formData.contentUrl,
      "embedUrl": formData.embedUrl,
      "duration": duration,
      "potentialAction": formData.seekToAction
        ? {
            "@type": "SeekToAction",
            "target": formData.seekToAction,
          }
        : undefined,
    };

    setGeneratedSchema(JSON.stringify(schema, null, 2));
  };

  const handleCopySchema = () => {
    navigator.clipboard.writeText(generatedSchema);
   toast.info("Schema copied to clipboard!");
  };

  const deleteSchema = () => {
    setGeneratedSchema({
      "@context": "https://schema.org",
      "@type": "VideoObject",
      "name": "demo",
      "description": "demo",
      "uploadDate": "2025-01-09",
      "thumbnailUrl": "https://example.com/",
      "contentUrl": "https://example.com/",
      "embedUrl": "https://example.com/",
      "duration": "PT10M600S",
      "potentialAction": {
        "@type": "SeekToAction",
        "target": "https://example.com/"
      }
    });
  
    toast.warning("Schema reset to dummy data!");
  };
  
  const handleSubmit = (e) => {
    e.preventDefault();
    generateSchema();
  };

  return (
    <div className="container mt-4">
      <h3 className="mb-4">Video Schema Generator</h3>
      <ToastContainer/>
    <div className="row">
    <div className="col-md-6">
    <form onSubmit={handleSubmit} className="card p-4 shadow-sm">
        {/* Video Details */}
        <div className="row mb-3">
          <div className="col-md-12">
            <label className="form-label">Name</label>
            <input
              type="text"
              className="form-control"
              name="name"
              value={formData.name}
              onChange={handleInputChange}
              placeholder="Enter video name"
            />
          </div>
          <div className="col-md-12">
            <label className="form-label">Description</label>
            <textarea
              className="form-control"
              name="description"
              value={formData.description}
              onChange={handleInputChange}
              placeholder="Enter video description"
              rows="3"
            ></textarea>
          </div>
        </div>

        {/* Upload Date and Duration */}
        <div className="row mb-3">
          <div className="col-md-4">
            <label className="form-label">Upload Date</label>
            <input
              type="date"
              className="form-control"
              name="uploadDate"
              value={formData.uploadDate}
              onChange={handleInputChange}
            />
          </div>
          <div className="col-md-4">
            <label className="form-label">Duration (Minutes)</label>
            <input
              type="number"
              className="form-control"
              name="durationMinutes"
              value={formData.durationMinutes}
              onChange={handleInputChange}
              placeholder="Enter minutes"
            />
          </div>
          <div className="col-md-4">
            <label className="form-label">Duration (Seconds)</label>
            <input
              type="number"
              className="form-control"
              name="durationSeconds"
              value={formData.durationSeconds}
              onChange={handleInputChange}
              placeholder="Enter seconds"
            />
          </div>
        </div>

        {/* Thumbnail, Content, and Embed URLs */}
        <div className="row mb-3">
          <div className="col-md-6">
            <label className="form-label">Thumbnail URL</label>
            <input
              type="text"
              className="form-control"
              name="thumbnailUrl"
              value={formData.thumbnailUrl}
              onChange={handleInputChange}
              placeholder="Enter thumbnail URL"
            />
          </div>
          <div className="col-md-6">
            <label className="form-label">Content URL</label>
            <input
              type="text"
              className="form-control"
              name="contentUrl"
              value={formData.contentUrl}
              onChange={handleInputChange}
              placeholder="Enter content URL"
            />
          </div>
        </div>

        <div className="row mb-3">
          <div className="col-md-6">
            <label className="form-label">Embed URL</label>
            <input
              type="text"
              className="form-control"
              name="embedUrl"
              value={formData.embedUrl}
              onChange={handleInputChange}
              placeholder="Enter embed URL"
            />
          </div>
          <div className="col-md-6">
            <label className="form-label">SeekToAction Target URL</label>
            <input
              type="text"
              className="form-control"
              name="seekToAction"
              value={formData.seekToAction}
              onChange={handleInputChange}
              placeholder="Enter SeekToAction target URL"
            />
          </div>
        </div>

        {/* Submit Button */}
        <button type="submit" className="btn btn-success w-100">
          Generate Schema
        </button>
      </form>
      </div>
      <div className="col-md-6">
        {/* JSON-LD Preview and Actions */}
        <div className="d-flex justify-content-center align-items-center mb-3 mt-3">
  <button className="btn btn-primary me-2" onClick={handleCopySchema}>
    Copy
  </button>
  <button className="btn btn-danger me-2" onClick={deleteSchema}>
    Reset
  </button>
  <button className="btn btn-info me-2">
    <a
      target="_blank"
      rel="noopener noreferrer"
      className="text-decoration-none text-white"
      href="https://developers.google.com/search/docs/appearance/structured-data"
    >
      Validate
    </a>
  </button>
  <button className="btn btn-success">
    <a
      target="_blank"
      rel="noopener noreferrer"
      className="text-decoration-none text-white"
      href="https://search.google.com/test/rich-results"
    >
      Test
    </a>
  </button>
</div>
      {generatedSchema && (
        <div className="mt-4">
          <h5>Generated JSON-LD:</h5>
          <JSONPretty
                  id="json-pretty"
                  data={generatedSchema}
                  className="bg-light p-3 rounded border"
                ></JSONPretty>
         
          
          
        </div>
      )}
        </div>
    </div>

      
    </div>
  );
};

export default VideoSchemaForm;
